import React, { useState } from 'react';
import { Menu, X, ArrowRight, CheckCircle, Zap, FileText, Users, Globe, Briefcase, Mail, Phone, Linkedin, RefreshCw, MessageSquare, Plug, Monitor, LifeBuoy, FileCheck, Cpu } from 'lucide-react';
export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('migration');
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  const serviceDescriptions = {
    migration: {
      title: 'Migration',
      description: 'Seamlessly transition your legacy systems to SAP S/4HANA with minimal disruption. Our migration experts ensure data integrity, system compatibility, and business continuity throughout the transformation process. We employ proven methodologies and industry best practices to reduce risk and accelerate time-to-value, helping you modernize your enterprise landscape with confidence.',
      backgroundImage: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80'
    },
    consulting: {
      title: 'Consulting',
      description: 'Strategic guidance from industry veterans who understand your business challenges. We provide comprehensive roadmaps, best practice recommendations, and hands-on support to optimize your SAP landscape. Our consultants work closely with your team to identify opportunities, solve complex problems, and drive measurable business outcomes that align with your strategic objectives.',
      backgroundImage: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80'
    },
    integration: {
      title: 'Integration',
      description: 'Connect your SAP ecosystem with third-party applications, cloud services, and legacy systems. Our integration specialists leverage SAP BTP, APIs, and middleware to create seamless data flows and unified business processes. We ensure your systems communicate effectively, enabling real-time data exchange and streamlined operations across your entire enterprise.',
      backgroundImage: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80'
    },
    implementation: {
      title: 'Implementation',
      description: 'Full-cycle SAP implementation services from requirements gathering to go-live support. We configure, customize, and deploy SAP solutions tailored to your specific business needs. Our implementation approach focuses on delivering optimal performance, ensuring user adoption, and establishing a solid foundation for future growth and innovation.',
      backgroundImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80'
    },
    support: {
      title: 'Support',
      description: 'Ongoing maintenance and support to keep your SAP systems running smoothly. Our dedicated support team provides rapid issue resolution, system monitoring, performance optimization, and continuous improvement recommendations. We offer flexible support models designed to meet your specific needs, ensuring maximum uptime and system reliability.',
      backgroundImage: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=80'
    },
    fiorization: {
      title: 'Fiorization',
      description: 'Transform your SAP user experience with modern, intuitive Fiori interfaces. We design and develop custom Fiori apps that enhance productivity, improve user satisfaction, and provide seamless access across devices. Our Fiorization services help you modernize your SAP UI/UX, making complex processes simple and improving overall user engagement.',
      backgroundImage: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80'
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-[#1a2845] shadow-lg z-50" data-id="element-1">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-2">
          <div className="flex justify-between items-center h-20" data-id="element-3">
            <div className="text-3xl font-bold text-white" data-id="element-4">A6UN</div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-5">
              <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-white transition-colors" data-id="element-6">
                Services
              </button>
              <button onClick={() => scrollToSection('expertise')} className="text-gray-300 hover:text-white transition-colors" data-id="element-7">
                Expertise
              </button>
              <button onClick={() => scrollToSection('success-stories')} className="text-gray-300 hover:text-white transition-colors" data-id="element-8">
                Success Stories
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-[#0066cc] text-white px-6 py-3 rounded hover:bg-[#0052a3] transition-colors font-medium" data-id="element-9">
                CONTACT US
              </button>
            </div>
            {/* Mobile Menu Button */}
            <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-10">
              {mobileMenuOpen ? <X size={24} data-id="element-11" /> : <Menu size={24} data-id="element-12" />}
            </button>
          </div>
          {/* Mobile Menu */}
          {mobileMenuOpen && <div className="md:hidden py-4 space-y-4" data-id="element-13">
              <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-300 hover:text-white py-2" data-id="element-14">
                Services
              </button>
              <button onClick={() => scrollToSection('expertise')} className="block w-full text-left text-gray-300 hover:text-white py-2" data-id="element-15">
                Expertise
              </button>
              <button onClick={() => scrollToSection('success-stories')} className="block w-full text-left text-gray-300 hover:text-white py-2" data-id="element-16">
                Success Stories
              </button>
              <button onClick={() => scrollToSection('contact')} className="w-full bg-[#0066cc] text-white px-6 py-3 rounded hover:bg-[#0052a3] transition-colors font-medium" data-id="element-17">
                CONTACT US
              </button>
            </div>}
        </div>
      </nav>
      {/* Hero Section */}
      <section className="pt-20 relative overflow-hidden bg-[#1a2845] min-h-[600px] flex items-center" data-id="element-18">
        <div className="absolute inset-0 z-0" data-id="element-19">
          <img src="https://i0.wp.com/tpiefficiency.com/wp-content/uploads/2025/08/smart-network-connection-technology-concept-with-bangkok-city-background-night-thailand-panorama-view.jpg" alt="Digital technology background" className="w-full h-full object-cover opacity-30" data-id="element-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a2845] via-[#1a2845]/90 to-transparent" data-id="element-21"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 relative z-10" data-id="element-22">
          <div className="max-w-3xl" data-id="element-23">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-24">
              Expert SAP Solutions. Personalized Delivery.
            </h1>
            <button onClick={() => scrollToSection('contact')} className="bg-white text-[#1a2845] px-8 py-4 rounded font-bold hover:bg-gray-100 transition-colors text-lg" data-id="element-25">
              Schedule Consultation
            </button>
          </div>
        </div>
      </section>
      {/* Trust Section with Stats */}
      <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-26">
        <div className="max-w-7xl mx-auto" data-id="element-27">
          <div className="grid lg:grid-cols-2 gap-12 items-start mb-16" data-id="element-28">
            <div data-id="element-29">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#1a2845] leading-tight" data-id="element-30">
                A6UN IS YOUR TRUSTED PARTNER WITHIN THE SAP ECOSYSTEM
              </h2>
            </div>
            <div data-id="element-31">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-32">
                A6UN is a boutique consultancy specializing in SAP S/4HANA
                transformation, strategic PMO leadership, and intelligent
                automation. We partner with organizations in the UK, EU and USA
                to optimize complex enterprise landscapes. Our expert-led
                approach ensures you receive high-quality, personalized service
                designed to deliver measurable results.
              </p>
            </div>
          </div>
          {/* The A6UN Advantage */}
          <div className="mt-20" data-id="element-33">
            <div className="text-center mb-12" data-id="element-34">
              <h2 className="text-4xl font-bold text-[#1a2845] mb-4" data-id="element-35">
                The A6UN Advantage
              </h2>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-36">
                We provide a clear alternative to large, impersonal consulting
                firms.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-37">
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow" data-id="element-38">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center mb-6" data-id="element-39">
                  <Users className="text-white" size={24} data-id="element-40" />
                </div>
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-41">
                  Boutique Focus, Senior Expertise
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-42">
                  You work directly with senior, hands-on experts. We provide
                  the personalized attention and deep knowledge that large firms
                  can't match.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow" data-id="element-43">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center mb-6" data-id="element-44">
                  <Zap className="text-white" size={24} data-id="element-45" />
                </div>
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-46">
                  Future-Ready Solutions
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-47">
                  We are not just SAP experts; we are automation specialists. We
                  connect your ERP core to the AI and RPA solutions that will
                  define the future of your business.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow" data-id="element-48">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center mb-6" data-id="element-49">
                  <Globe className="text-white" size={24} data-id="element-50" />
                </div>
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-51">
                  Trans-Atlantic Presence
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-52">
                  With registered companies in both the UK (A6UN Limited) and
                  the USA (A6UN LLC), we are perfectly positioned to support
                  your operations on both sides of the Atlantic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Expertise Section */}
      <section className="py-20 px-6 lg:px-8 bg-gray-50" data-id="element-53">
        <div className="max-w-7xl mx-auto" data-id="element-54">
          <div className="mb-12" data-id="element-55">
            <h2 className="text-4xl font-bold text-[#1a2845] mb-4" data-id="element-56">
              Our Core Service Offerings
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl" data-id="element-57">
              We provide end-to-end services focused on maximizing the value of
              your SAP investment.
            </p>
          </div>
        </div>
      </section>
      {/* SAP Services Section */}
      <section id="services" className="py-20 px-6 lg:px-8 bg-[#0066cc]" data-id="element-58">
        <div className="max-w-7xl mx-auto" data-id="element-59">
          <div className="grid lg:grid-cols-2 gap-12" data-id="element-60">
            {/* Left side - Service buttons */}
            <div className="space-y-4" data-id="element-61">
              <button onClick={() => setSelectedService('migration')} className={`w-full ${selectedService === 'migration' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-62">
                <div className="flex items-center gap-4" data-id="element-63">
                  <RefreshCw size={24} data-id="element-64" />
                  <span className="text-xl font-bold" data-id="element-65">Migration</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-66" />
              </button>
              <button onClick={() => setSelectedService('consulting')} className={`w-full ${selectedService === 'consulting' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-67">
                <div className="flex items-center gap-4" data-id="element-68">
                  <MessageSquare size={24} data-id="element-69" />
                  <span className="text-xl font-bold" data-id="element-70">Consulting</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-71" />
              </button>
              <button onClick={() => setSelectedService('integration')} className={`w-full ${selectedService === 'integration' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-72">
                <div className="flex items-center gap-4" data-id="element-73">
                  <Plug size={24} data-id="element-74" />
                  <span className="text-xl font-bold" data-id="element-75">Integration</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-76" />
              </button>
              <button onClick={() => setSelectedService('implementation')} className={`w-full ${selectedService === 'implementation' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-77">
                <div className="flex items-center gap-4" data-id="element-78">
                  <Monitor size={24} data-id="element-79" />
                  <span className="text-xl font-bold" data-id="element-80">Implementation</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-81" />
              </button>
              <button onClick={() => setSelectedService('support')} className={`w-full ${selectedService === 'support' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-82">
                <div className="flex items-center gap-4" data-id="element-83">
                  <LifeBuoy size={24} data-id="element-84" />
                  <span className="text-xl font-bold" data-id="element-85">Support</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-86" />
              </button>
              <button onClick={() => setSelectedService('fiorization')} className={`w-full ${selectedService === 'fiorization' ? 'bg-[#0052a3]' : 'bg-[#0066cc]/80'} hover:bg-[#0052a3] text-white p-6 rounded-lg flex items-center justify-between transition-colors group`} data-id="element-87">
                <div className="flex items-center gap-4" data-id="element-88">
                  <FileCheck size={24} data-id="element-89" />
                  <span className="text-xl font-bold" data-id="element-90">Fiorization</span>
                </div>
                <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" data-id="element-91" />
              </button>
            </div>
            {/* Right side - Description with background */}
            <div className="text-white rounded-lg overflow-hidden relative p-8 flex flex-col justify-center min-h-[500px]" style={{
            backgroundImage: `url(${serviceDescriptions[selectedService].backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }} data-id="element-92">
              <div className="absolute inset-0 bg-gradient-to-r from-[#1a2845]/95 via-[#1a2845]/90 to-[#1a2845]/80" data-id="element-93"></div>
              <div className="relative z-10" data-id="element-94">
                <h3 className="text-3xl font-bold mb-6" data-id="element-95">
                  {serviceDescriptions[selectedService].title}
                </h3>
                <p className="text-lg text-gray-200 leading-relaxed" data-id="element-96">
                  {serviceDescriptions[selectedService].description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* SAP Solutions Section */}
      <section className="py-20 px-6 lg:px-8 bg-white" data-id="element-97">
        <div className="max-w-7xl mx-auto" data-id="element-98">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-99">
            <div data-id="element-100">
              <h2 className="text-4xl font-bold text-[#1a2845] mb-6" data-id="element-101">
                Beyond ERP: The Future of Automation
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-102">
                We bridge the gap between your core SAP system and the next
                generation of intelligent automation. We help you build a
                hyper-efficient enterprise by automating processes across your
                entire organization.
              </p>
            </div>
            <div data-id="element-103">
              <img src="https://assets.new.siemens.com/siemens/assets/api/uuid:8000762d-a55d-4459-990e-c0091c57422b/width:3840/quality:high/SIE-180665-CCT-KeyVisual-05-FOA-RGB-300dpi.jpg" alt="SAP Solutions" className="rounded-lg shadow-xl" data-id="element-104" />
            </div>
          </div>
          {/* Solution Cards */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-105">
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-106">
              <div className="flex items-center justify-between mb-4" data-id="element-107">
                <Globe size={32} data-id="element-108" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-109">
                Business Technology Platform (BTP)
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-110">
                Integrate, extend, and innovate with SAP's cloud platform for
                building intelligent enterprise applications.
              </p>
            </button>
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-111">
              <div className="flex items-center justify-between mb-4" data-id="element-112">
                <Briefcase size={32} data-id="element-113" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-114">Spend Management</h3>
              <p className="text-gray-300 text-sm" data-id="element-115">
                Optimize procurement, travel, and expense management with
                intelligent spend control solutions.
              </p>
            </button>
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-116">
              <div className="flex items-center justify-between mb-4" data-id="element-117">
                <FileText size={32} data-id="element-118" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-119">Data & Analytics</h3>
              <p className="text-gray-300 text-sm" data-id="element-120">
                Transform data into actionable insights with advanced analytics
                and business intelligence tools.
              </p>
            </button>
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-121">
              <div className="flex items-center justify-between mb-4" data-id="element-122">
                <Zap size={32} data-id="element-123" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-124">
                Artificial Intelligence
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-125">
                Leverage AI and machine learning to automate processes and drive
                intelligent decision-making.
              </p>
            </button>
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-126">
              <div className="flex items-center justify-between mb-4" data-id="element-127">
                <RefreshCw size={32} data-id="element-128" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-129">
                Product Lifecycle Management (PLM)
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-130">
                Manage product development from concept to retirement with
                integrated PLM solutions.
              </p>
            </button>
            <button className="bg-[#1a2845] hover:bg-[#0f1a2e] text-white p-8 rounded-lg text-left transition-colors group" data-id="element-131">
              <div className="flex items-center justify-between mb-4" data-id="element-132">
                <Globe size={32} data-id="element-133" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-134">
                Supply Chain Management
              </h3>
              <p className="text-gray-300 text-sm" data-id="element-135">
                Optimize end-to-end supply chain operations with real-time
                visibility and intelligent planning.
              </p>
            </button>
          </div>
        </div>
      </section>
      {/* Extended Services */}
      <section id="expertise" className="py-20 px-6 lg:px-8 bg-gray-50" data-id="element-136">
        <div className="max-w-7xl mx-auto" data-id="element-137">
          <div className="mb-12" data-id="element-138">
            <h2 className="text-4xl font-bold text-[#1a2845] mb-4" data-id="element-139">
              Your Expert Partner in Digital Transformation
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl" data-id="element-140">
              We provide comprehensive enterprise services of any type and scale
              for your effective digital transformation and IT infrastructure
              optimization.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-141">
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-142">
              <div className="flex items-center justify-between mb-4" data-id="element-143">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-144">
                  <CheckCircle className="text-white" size={24} data-id="element-145" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-146">
                Change Management
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-147">
                Guide your organization through transformation with structured
                change strategies and stakeholder engagement.
              </p>
            </button>
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-148">
              <div className="flex items-center justify-between mb-4" data-id="element-149">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-150">
                  <Users className="text-white" size={24} data-id="element-151" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-152">
                Business Consulting
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-153">
                Strategic advisory services to optimize business processes and
                drive operational excellence.
              </p>
            </button>
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-154">
              <div className="flex items-center justify-between mb-4" data-id="element-155">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-156">
                  <Monitor className="text-white" size={24} data-id="element-157" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-158">
                Enterprise Software Development
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-159">
                Custom software solutions designed to meet complex enterprise
                requirements and scale with your business.
              </p>
            </button>
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-160">
              <div className="flex items-center justify-between mb-4" data-id="element-161">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-162">
                  <Phone className="text-white" size={24} data-id="element-163" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-164">
                Mobile Development
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-165">
                Native and cross-platform mobile applications that deliver
                seamless user experiences across devices.
              </p>
            </button>
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-166">
              <div className="flex items-center justify-between mb-4" data-id="element-167">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-168">
                  <Globe className="text-white" size={24} data-id="element-169" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-170">
                Web Development
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-171">
                Modern web applications built with cutting-edge technologies for
                optimal performance and user engagement.
              </p>
            </button>
            <button className="bg-white hover:shadow-lg p-8 rounded-lg text-left transition-all border-2 border-gray-200 hover:border-[#0066cc] group" data-id="element-172">
              <div className="flex items-center justify-between mb-4" data-id="element-173">
                <div className="w-12 h-12 bg-[#0066cc] rounded-lg flex items-center justify-center" data-id="element-174">
                  <Cpu className="text-white" size={24} data-id="element-175" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#1a2845] mb-3" data-id="element-176">
                Agentic AI Automation
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-177">
                Deploy intelligent AI agents that autonomously handle complex
                workflows, make decisions, and interact with systems to drive
                unprecedented efficiency and innovation.
              </p>
            </button>
          </div>
        </div>
      </section>
      {/* Trusted by Industry Leaders */}
      <section className="py-16 px-6 lg:px-8 bg-white" data-id="element-178">
        <div className="max-w-7xl mx-auto" data-id="element-179">
          <h2 className="text-3xl font-bold text-[#1a2845] text-center mb-12" data-id="element-180">
            Trusted by Industry Leaders
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center" data-id="element-181">
            <div className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all" data-id="element-182">
              <img src="https://1000logos.net/wp-content/uploads/2017/01/GSK-Logo-1.jpg" alt="GSK" className="max-h-16 w-auto object-contain" data-id="element-183" />
            </div>
            <div className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all" data-id="element-184">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/F._Hoffmann-La_Roche_2021_logo.svg/1200px-F._Hoffmann-La_Roche_2021_logo.svg.png" alt="Roche" className="max-h-16 w-auto object-contain" data-id="element-185" />
            </div>
            <div className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all" data-id="element-186">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/2560px-Sony_logo.svg.png" alt="Sony" className="max-h-16 w-auto object-contain" data-id="element-187" />
            </div>
            <div className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all" data-id="element-188">
              <img src="https://mma.prnewswire.com/media/550092/UNIVAR_LOGO.jpg" alt="Univar" className="max-h-16 w-auto object-contain" data-id="element-189" />
            </div>
            <div className="flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all col-span-2 md:col-span-3 lg:col-span-1" data-id="element-190">
              <img src="https://static.wikia.nocookie.net/logopedia/images/c/cb/Birds_Eye_UK_2023.png" alt="Birds Eye" className="max-h-16 w-auto object-contain" data-id="element-191" />
            </div>
          </div>
        </div>
      </section>
      {/* Success Stories */}
      <section id="success-stories" className="py-20 px-6 lg:px-8 bg-gray-50" data-id="element-192">
        <div className="max-w-7xl mx-auto" data-id="element-193">
          <div className="flex justify-between items-center mb-12" data-id="element-194">
            <h2 className="text-4xl font-bold text-[#1a2845]" data-id="element-195">
              Proven Expertise. Tangible Results.
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-196">
            {/* Case Study 1 */}
            <div className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-197">
              <img src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80" alt="Logistics company" className="w-full h-64 object-cover" data-id="element-198" />
              <div className="p-8" data-id="element-199">
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-200">
                  Global S/4 HANA Program Leadership
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-201">
                  Our senior leadership has a proven track record of managing
                  large-scale, multi-country SAP S/4HANA rollouts. We have
                  successfully navigated the complexities of global templates,
                  localized legal requirements, and cross-functional team
                  coordination for clients in manufacturing, logistics, and
                  technology.
                </p>
              </div>
            </div>
            {/* Case Study 2 */}
            <div className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-202">
              <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80" alt="Manufacturing facility" className="w-full h-64 object-cover" data-id="element-203" />
              <div className="p-8" data-id="element-204">
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-205">
                  Pharma & Life Sciences Harmonization
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-206">
                  We have deep experience supporting global pharmaceutical
                  clients. We specialize in harmonizing complex, regulated
                  processes (Demand-to-Pay, Source-to-Pay) across divisions. We
                  act as the expert liaison between Finance, Procurement, and IT
                  to ensure your S/4HANA and Ariba platforms not only drive
                  efficiency but also maintain strict compliance with global GxP
                  and validation standards.
                </p>
              </div>
            </div>
            {/* Case Study 3 */}
            <div className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-207">
              <img src="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80" alt="Invoice processing" className="w-full h-64 object-cover" data-id="element-208" />
              <div className="p-8" data-id="element-209">
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-210">
                  AI-Driven Invoice Processing
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-211">
                  Our team possesses deep expertise in architecting and
                  implementing sophisticated, AI-driven invoice processing
                  solutions. We leverage AI and OCR to fully automate data
                  extraction, implement 3-way matching against POs, and manage
                  exceptions. This approach drastically reduces manual
                  intervention, enhances accuracy, and transforms accounts
                  payable into a high-efficiency, data-driven function.
                </p>
              </div>
            </div>
            {/* Case Study 4 */}
            <div className="bg-gray-50 rounded-lg overflow-hidden hover:shadow-xl transition-shadow" data-id="element-212">
              <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80" alt="Business team" className="w-full h-64 object-cover" data-id="element-213" />
              <div className="p-8" data-id="element-214">
                <h3 className="text-2xl font-bold text-[#1a2845] mb-4" data-id="element-215">
                  Strategic Demand-to-Pay Optimization
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-216">
                  Our team brings hands-on leadership from managing complex,
                  global Demand-to-Pay (D2P) processes. We specialize in
                  re-engineering end-to-end procurement workflows, from 'Source
                  to Pay' to 'Invoice to Pay', acting as the critical bridge
                  between Finance, Procurement, and IT. We ensure your SAP
                  S/4HANA (MM, MDG) and Ariba solutions are aligned with global
                  goals, driving harmonization, automation, and compliance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="py-20 px-6 lg:px-8 bg-[#0066cc] relative overflow-hidden" data-id="element-217">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-218">
          <div className="bg-white rounded-3xl p-10 lg:p-16 shadow-2xl" data-id="element-219">
            <div className="text-center mb-10" data-id="element-220">
              <h2 className="text-4xl font-bold text-[#1a2845] mb-4" data-id="element-221">
                Get in Touch
              </h2>
              <p className="text-gray-700 text-lg mb-6" data-id="element-222">
                Contact our team today for a consultation to discuss your SAP
                and automation challenges.
              </p>
              <div className="flex items-center justify-center gap-2 text-[#0066cc]" data-id="element-223">
                <Mail size={20} data-id="element-224" />
                <a href="mailto:contact@a6un.com" className="text-lg font-medium hover:underline" data-id="element-225">
                  contact@a6un.com
                </a>
              </div>
            </div>
            <form className="space-y-6" data-id="element-226">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-227">
                <div data-id="element-228">
                  <input type="text" placeholder="*Name (Required)" className="w-full px-6 py-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-[#0066cc] outline-none" data-id="element-229" />
                </div>
                <div data-id="element-230">
                  <input type="text" placeholder="Company (Optional)" className="w-full px-6 py-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-[#0066cc] outline-none" data-id="element-231" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-232">
                <div data-id="element-233">
                  <input type="email" placeholder="*Email (Required)" className="w-full px-6 py-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-[#0066cc] outline-none" data-id="element-234" />
                </div>
                <div data-id="element-235">
                  <input type="tel" placeholder="Phone" className="w-full px-6 py-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-[#0066cc] outline-none" data-id="element-236" />
                </div>
              </div>
              <div data-id="element-237">
                <textarea rows={5} placeholder="Tell us about your project..." className="w-full px-6 py-4 bg-gray-100 border-0 rounded-lg focus:ring-2 focus:ring-[#0066cc] outline-none resize-none" data-id="element-238" />
              </div>
              <button type="submit" className="w-full bg-[#0066cc] text-white px-8 py-4 rounded-lg hover:bg-[#0052a3] transition-colors font-bold text-lg" data-id="element-239">
                SEND MESSAGE
              </button>
            </form>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="bg-[#1a2845] text-white py-12 px-6 lg:px-8" data-id="element-240">
        <div className="max-w-7xl mx-auto" data-id="element-241">
          <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-242">
            <div data-id="element-243">
              <div className="text-3xl font-bold mb-4" data-id="element-244">A6UN</div>
              <p className="text-gray-400 text-sm" data-id="element-245">
                Expert SAP Solutions. Personalized Delivery.
              </p>
            </div>
            <div data-id="element-246">
              <h4 className="font-bold mb-4" data-id="element-247">UK Office</h4>
              <p className="text-gray-400 text-sm" data-id="element-248">
                A6UN Limited
                <br data-id="element-249" />
                Highland House 165 The Broadway, Wimbledon, London, England,
                SW19 1NE United Kingdom
              </p>
            </div>
            <div data-id="element-250">
              <h4 className="font-bold mb-4" data-id="element-251">USA Office</h4>
              <p className="text-gray-400 text-sm" data-id="element-252">
                A6UN LLC
                <br data-id="element-253" />
                7700 Preston Rd, Suite 304, Frisco, TX 75034 USA
              </p>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8 text-center text-gray-400 text-sm" data-id="element-254">
            © 2025 A6UN. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}